import { AssessmentQuestion } from "./assessment"

export interface QuizProps {
    id: number
    name: string
    questions: AssessmentQuestion[]
    totalPoint: number
    totalTime: number
    url: string
    scormUrl: string
    is_active: number
}
export interface QuizSetting {
    showCorrectAnswer: number
    showRanking: number
    questionTime: number
}
export interface QuizCurrentQuestion {
    id: number
    startTime: number
    totalTime: number
    state: string
    remaining: number
}

export enum QuizState {
    NOT_STARTED = 'not_started',
    ON_GOING = 'on_going',
    FINISHED = 'finished',
}

export enum QuestionState {
    ON_GOING = 'on_going',
    REVIEW = 'review',
    FINISHED = 'finished'
}

export enum QuizAudioKey {
    BGM = 'bgm',
    SFX = 'sfx',
    question = 'question',
    answer = 'answer'
}